import {NgModule} from '@angular/core';
import {CampaignServiceProvider} from "./services/campaign-service/campaign-service";
import {KpiServiceProvider} from "./services/kpi-service/kpi-service";
import {RankingServiceProvider} from "./services/ranking-service/ranking-service";
import {TasksServiceProvider} from "./services/tasks-service/tasks-service";

@NgModule({
  providers: [
    CampaignServiceProvider,
    KpiServiceProvider,
    RankingServiceProvider,
    TasksServiceProvider
  ]
})
export class SellionsRankingModule {}



// WEBPACK FOOTER //
// ./src/modules/ranking/ranking.module.ts